module.exports = __webpack_public_path__ + "static/media/Olaf.305f00d6.png";